import { render, staticRenderFns } from "./terms-component.vue?vue&type=template&id=a7d37112&scoped=true&"
import script from "./terms-component.vue?vue&type=script&lang=js&"
export * from "./terms-component.vue?vue&type=script&lang=js&"
import style0 from "./terms-component.vue?vue&type=style&index=0&id=a7d37112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d37112",
  null
  
)

export default component.exports